import { render, staticRenderFns } from "./MetricSectionList.vue?vue&type=template&id=64f38d4d&scoped=true"
import script from "./MetricSectionList.vue?vue&type=script&lang=js"
export * from "./MetricSectionList.vue?vue&type=script&lang=js"
import style0 from "./MetricSectionList.vue?vue&type=style&index=0&id=64f38d4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f38d4d",
  null
  
)

export default component.exports